import { ArcElement, Chart, ChartData, Tooltip } from 'chart.js';
import dynamic from 'next/dynamic';
import { colors } from 'ui-components';

const Doughnut = dynamic(
  () => import('react-chartjs-2').then((mod) => mod.Doughnut),
  {
    ssr: false,
  },
);

Chart.register(ArcElement, Tooltip);

export const colorFemale = colors.secondary[500];
export const colorMale = colors.tertiary[600];
export const colorOther = colors.softPink[600];

type GenderValues = {
  values: {
    male: number;
    female: number;
    other?: number;
  };
};

const getGenderLabels = (values: GenderValues['values']) => {
  const labels = ['Male', 'Female'];
  const data = [values.male, values.female];
  if (values.other) {
    labels.push('Other');
    data.push(values.other);
  }
  return { labels, data };
};

export const GenderDonut = ({ values }: GenderValues) => {
  const { labels, data: genderData } = getGenderLabels(values);

  const data: ChartData<'doughnut'> = {
    labels,
    datasets: [
      {
        data: genderData,
        backgroundColor: [colorMale, colorFemale, colorOther],
        hoverOffset: 4,
      },
    ],
  };

  return (
    <Doughnut
      data={data}
      options={{
        plugins: {
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return ' ' + tooltipItem.formattedValue + '%';
              },
            },
          },
        },
        animation: false,
      }}
    />
  );
};
